import { action, observable, runInAction } from 'mobx';
// import moment from 'moment';
import compact from 'lodash/compact';
import orderBy from 'lodash/orderBy';
import reportController from './controller';
import {
  MultiPaymentReportItem,
  TBankMultiPaymentReportRequest,
  TBankPartnerLegalItem,
  TBankPartnerLegalRequest,
} from './tBankreportApi';

export interface TBankReportStore {
  loading: boolean;
  error: string;
  multiPaymentReport: MultiPaymentReportItem[];
  multiPaymentReportRequest: TBankMultiPaymentReportRequest;
  tBankPartnerLegals: TBankPartnerLegalItem[],
  tBankPartnerLegalsRequest: TBankPartnerLegalRequest,
}

const initialValues: TBankReportStore = {
  loading: false,
  error: null,
  multiPaymentReport: [],
  multiPaymentReportRequest: null,
  tBankPartnerLegals: [],
  tBankPartnerLegalsRequest: null,
};

export const tBankReportStore = observable(initialValues);

// ==================== HELPER FUNCTIONS ====================

const handleError = (error: string) => {
  tBankReportStore.error = error;
};

const setLoading = action(() => {
  tBankReportStore.loading = true;
});

const clearError = action(() => {
  tBankReportStore.error = null;
});

// Универсальная функция загрузки отчёта
interface FetchReportOptions {
  method: string;
  request: any;
  path?: string; // 'data', 'data.items', 'data.content'
  transform?: (data: any) => any;
  sort?: { field: string; order: 'asc' | 'desc' };
  prepareRequest?: boolean; // обработать serviceIds
  setState: (data: any, request?: any) => void;
  onError?: () => void;
}

const fetchReport = async (options: FetchReportOptions) => {
  try {
    clearError();
    setLoading();

    let finalRequest = options.request;
    if (options.prepareRequest) {
      finalRequest = {
        ...options.request,
        serviceIds: compact(options.request.serviceIds ?? []),
      };
    }

    const response = await (reportController as any)[options.method](finalRequest);

    runInAction(() => {
      if (response.errorData) {
        tBankReportStore.error = response.errorData.message;
        options.onError?.();
        tBankReportStore.loading = false;
        return;
      }
      
      let data = response;
      if (options.path) {
        for (const part of options.path.split('.')) {
          data = data?.[part];
        }
      }

      if (options.transform) {
        data = options.transform(data);
      }

      if (options.sort) {
        data = orderBy(data, [options.sort.field], [options.sort.order]);
      }

      options.setState(data, options.prepareRequest ? finalRequest : options.request);
      tBankReportStore.loading = false;
    });
  } catch (err: any) {
    handleError(err.message);
    tBankReportStore.loading = false;
  }
};

// ==================== ACTIONS ====================

export const tBankReportsActions = {
  handleError,
  setLoading,
  clearError,

  async getMultiPaymentReport(request: TBankMultiPaymentReportRequest) {
    await fetchReport({
      method: 'getMultiPaymentReport',
      request,
      path: 'data.items',
      setState: (data: MultiPaymentReportItem[], req) => {
        tBankReportStore.multiPaymentReport = data;
        tBankReportStore.multiPaymentReportRequest = req;
      },
      onError: () => {
        tBankReportStore.multiPaymentReport = [];
        tBankReportStore.multiPaymentReportRequest = null;
      },
    });
  },

  clearMultisplitReport() {
    runInAction(() => {
      tBankReportStore.multiPaymentReportRequest = null;
      tBankReportStore.multiPaymentReport = [];
    });
  },

  async getTBankLegals(request: TBankPartnerLegalRequest) {    
    await fetchReport({
      method: 'getTBankLegals',
      request,
      path: 'data.items',
      setState: (data: TBankPartnerLegalItem[], req) => {
        tBankReportStore.tBankPartnerLegals = data;
        tBankReportStore.tBankPartnerLegalsRequest = req;
      },
      onError: () => {
        tBankReportStore.tBankPartnerLegals = [];
        tBankReportStore.tBankPartnerLegalsRequest = null;
      },
    });
  },

  clearTBankLegals() {
    runInAction(() => {
      tBankReportStore.tBankPartnerLegalsRequest = null;
      tBankReportStore.tBankPartnerLegals = [];
    });
  },

};